import { render, staticRenderFns } from "./Yogas.vue?vue&type=template&id=3d32d2ea&scoped=true&"
import script from "./Yogas.vue?vue&type=script&lang=js&"
export * from "./Yogas.vue?vue&type=script&lang=js&"
import style0 from "./Yogas.vue?vue&type=style&index=0&id=3d32d2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d32d2ea",
  null
  
)

export default component.exports